// console.error but with a static ref that can be passed to use* dependency arrays
export const staticError = (message: string) => console.error(message);
